module.exports = __webpack_public_path__ + "videos/3d-export_en.9ebf1c1.webm";